module.exports = __webpack_public_path__ + "fonts/MyriadPro-Bold.9c2e25f.ttf";